/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Download_SanctionsInputs */



/**
* | output |
* | --- |
* | "Download the event's sanctions" |
*
* @param {Tools_Download_SanctionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_download_sanctions = /** @type {((inputs?: Tools_Download_SanctionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Download_SanctionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger les sanctions de l'événement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar las sanciones del evento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar as sanções do evento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica le sanzioni dell'evento")
	return /** @type {LocalizedString} */ ("Download the event's sanctions")
});